import React, { useState } from "react";
import MainMenu from "../../components/MainMenu";
import Button from "@mui/material/Button";
import { Grid, Paper } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import PlayerAccountSettings from "../../components/PlayersAreaComponents/PlayerAccountSettings";
import { apiGet } from "../../utils/apiRequests";
function PlayerAccountPage() {
  const location = useLocation();
  const { id } = useParams();
  const [playerData, setPlayerData] = useState(location.state.playerData);

  const isFromDashboard = location.state.isFromDashboard;

  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <PlayerAccountSettings
              playerData={playerData}
              playerID={isFromDashboard ? id : location.state.playerData._id}
              averageScore={location.state?.averageScore}
            />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
}

export default PlayerAccountPage;
